import CryptoJS from 'crypto-js';

export default function getDecrypt(permissionsList, appSecret) {
  const bytes = CryptoJS.AES.decrypt(permissionsList, appSecret);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
}

export function getEncrypt(permissionsList, appSecret) {
  return CryptoJS.AES.encrypt(JSON.stringify(permissionsList), appSecret).toString();
}
